
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topcamplejeunelawyers/contact-us",
      function () {
        return require("private-next-pages/topcamplejeunelawyers/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topcamplejeunelawyers/contact-us"])
      });
    }
  